import { atom } from 'recoil';

export const sendSuccessData = atom({
  key: 'sendSuccessData',
  default: undefined,
});
